import { sanitizeAgreementHtml } from '../../utilities/sanitizeHtml'
import { getDynamicTagValue } from '../agreement-content-editor/dynamicTags'

export function replaceDynamicTags (content, client, companyName = '') {
  const safeContent = sanitizeAgreementHtml(content)
  if (!safeContent || !client) {
    return safeContent
  }
  const parser = new DOMParser()
  const document = parser.parseFromString(
    safeContent,
    'text/html'
  )
  const tags = document.querySelectorAll(
    '.dynamic-tag[data-tag]'
  )
  tags.forEach((tag) => {
    tag.textContent = getDynamicTagValue(
      tag.getAttribute('data-tag'),
      client,
      companyName
    )
  })
  return sanitizeAgreementHtml(document.body.innerHTML)
}
